<template>
  <div class="vip-plan-page">
    <div class="toolbar">
      <el-button type="primary" @click="openDialog">新增套餐</el-button>
    </div>
    <el-table :data="list" stripe style="width:100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="套餐名称" />
      <el-table-column prop="vip_level" label="VIP等级" width="100" />
      <el-table-column label="价格" width="200">
        <template #default="{row}">
          <div class="prices">
            <span v-if="row.month_price">月：{{ (row.month_price / 100).toFixed(2) }}元</span>
            <span v-if="row.year_price">年：{{ (row.year_price / 100).toFixed(2) }}元</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="show" label="显示" width="120">
        <template #default="{row}">
          <el-switch
            v-model="row.show"
            :active-value="1"
            :inactive-value="0"
            @change="toggleShow(row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="renew" label="可续费" width="120">
        <template #default="{row}">
          <el-switch
            v-model="row.renew"
            :active-value="1"
            :inactive-value="0"
            @change="toggleRenew(row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="80" />
      <el-table-column label="操作" width="200">
        <template #default="{row}">
          <el-button size="small" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="dialogVisible" :title="form.id ? '编辑套餐' : '新增套餐'" width="600px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="套餐名称">
          <el-input v-model="form.name" placeholder="请输入套餐名称" />
        </el-form-item>
        <el-form-item label="VIP等级">
          <el-input-number v-model="form.vip_level" :min="0" :max="10" />
        </el-form-item>
        <el-form-item label="是否显示">
          <el-switch v-model="form.show" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" />
        </el-form-item>
        <el-form-item label="是否可续费">
          <el-switch v-model="form.renew" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="套餐描述">
          <el-input v-model="form.content" type="textarea" :rows="3" placeholder="请输入套餐描述" />
        </el-form-item>
        <el-form-item label="月付价格（元）">
          <el-input-number v-model="form.month_price_yuan" :precision="2" :min="0" :step="1" />
          <span class="tips">输入元，会自动转换为分</span>
        </el-form-item>
        <el-form-item label="季付价格（元）">
          <el-input-number v-model="form.quarter_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="半年付价格（元）">
          <el-input-number v-model="form.half_year_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="年付价格（元）">
          <el-input-number v-model="form.year_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="两年付价格（元）">
          <el-input-number v-model="form.two_year_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="三年付价格（元）">
          <el-input-number v-model="form.three_year_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="一次性价格（元）">
          <el-input-number v-model="form.onetime_price_yuan" :precision="2" :min="0" :step="1" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'
import store from '../../store'

const list = ref([])
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({
  id: null,
  name: '',
  vip_level: 1,
  show: 1,
  sort: 0,
  renew: 1,
  content: '',
  month_price_yuan: null,
  quarter_price_yuan: null,
  half_year_price_yuan: null,
  year_price_yuan: null,
  two_year_price_yuan: null,
  three_year_price_yuan: null,
  onetime_price_yuan: null
})

const loadList = async () => {
  try {
    const data = await request.get('/v1/admin/vip-plan/list')
    const raw = data.list || []
    list.value = raw.map(it => ({
      ...it,
      show: Number(it.show || 0),
      renew: Number(it.renew || 0)
    }))
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const openDialog = () => {
  form.value = {
    id: null,
    name: '',
    vip_level: 1,
    show: 1,
    sort: 0,
    renew: 1,
    content: '',
    month_price_yuan: null,
    quarter_price_yuan: null,
    half_year_price_yuan: null,
    year_price_yuan: null,
    two_year_price_yuan: null,
    three_year_price_yuan: null,
    onetime_price_yuan: null
  }
  dialogVisible.value = true
}

const edit = (row) => {
  form.value = {
    id: row.id,
    name: row.name,
    vip_level: row.vip_level || 1,
    show: Number(row.show || 0),
    sort: row.sort || 0,
    renew: row.renew !== undefined ? Number(row.renew) : 1,
    content: row.content || '',
    // 后端返回的数据已经包含 *_yuan 字段，直接使用
    month_price_yuan: row.month_price_yuan || (row.month_price ? (row.month_price / 100) : null),
    quarter_price_yuan: row.quarter_price_yuan || (row.quarter_price ? (row.quarter_price / 100) : null),
    half_year_price_yuan: row.half_year_price_yuan || (row.half_year_price ? (row.half_year_price / 100) : null),
    year_price_yuan: row.year_price_yuan || (row.year_price ? (row.year_price / 100) : null),
    two_year_price_yuan: row.two_year_price_yuan || (row.two_year_price ? (row.two_year_price / 100) : null),
    three_year_price_yuan: row.three_year_price_yuan || (row.three_year_price ? (row.three_year_price / 100) : null),
    onetime_price_yuan: row.onetime_price_yuan || (row.onetime_price ? (row.onetime_price / 100) : null)
  }
  dialogVisible.value = true
}

const submit = async () => {
  if (!form.value.name) {
    ElMessage.warning('请输入套餐名称')
    return
  }

  loading.value = true
  try {
    // 前端发送元为单位，后端负责转换为分
    const payload = {
      id: form.value.id,
      name: form.value.name,
      vip_level: form.value.vip_level,
      show: form.value.show,
      sort: form.value.sort,
      renew: form.value.renew,
      content: form.value.content || null,
      month_price_yuan: form.value.month_price_yuan || null,
      quarter_price_yuan: form.value.quarter_price_yuan || null,
      half_year_price_yuan: form.value.half_year_price_yuan || null,
      year_price_yuan: form.value.year_price_yuan || null,
      two_year_price_yuan: form.value.two_year_price_yuan || null,
      three_year_price_yuan: form.value.three_year_price_yuan || null,
      onetime_price_yuan: form.value.onetime_price_yuan || null
    }

    if (form.value.id) {
      await request.post('/v1/admin/vip-plan/update', payload)
    } else {
      await request.post('/v1/admin/vip-plan/create', payload)
    }
    ElMessage.success('操作成功')
    dialogVisible.value = false
    loadList()
  } catch (e) {
    console.error('保存套餐失败:', e)
    ElMessage.error('保存失败：' + e.toString())
  } finally {
    loading.value = false
  }
}

const remove = async (row) => {
  try {
    await ElMessageBox.confirm('确定要删除这个套餐吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await request.post('/v1/admin/vip-plan/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error(e.toString())
    }
  }
}

const toggleShow = async (row) => {
  try {
    await request.post('/v1/admin/vip-plan/update', { id: row.id, show: row.show })
    ElMessage.success('状态已更新')
    await loadList()
  } catch (e) {
    ElMessage.error('更新显示状态失败：' + e.toString())
    row.show = row.show ? 0 : 1
  }
}

const toggleRenew = async (row) => {
  try {
    await request.post('/v1/admin/vip-plan/update', { id: row.id, renew: row.renew })
    ElMessage.success('续费状态已更新')
    await loadList()
  } catch (e) {
    ElMessage.error('更新续费状态失败：' + e.toString())
    row.renew = row.renew ? 0 : 1
  }
}

onMounted(() => {
  if (store.state.token) {
    loadList()
  }
})
</script>

<style scoped>
.vip-plan-page .toolbar {
  margin-bottom: 15px;
}
.prices {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
}
.tips {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>

